import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";



function InscriptionsChamadas(props) {  

  return (
    <>
      <list-calls-page />
    </>
  );
}

export default injectIntl(withAuth(InscriptionsChamadas));

